module.exports = __webpack_public_path__ + "img/infowindow.c519a1e0.gif";